import { Grid, Box, Skeleton } from '@mui/material';
import React from 'react';

function SparksHistoryResultSkeleton() {
  return (
    <Grid container direction='column' paddingX={2} gap={2}>
      <Box display='flex' gap={2} justifyContent={'center'} width='100%'>
        <Skeleton
          variant='rectangular'
          height={150}
          sx={{
            backgroundColor: '#f0f0f0',
            borderRadius: '10px',
            width: '20%',
          }}
        />
        <Skeleton
          height={150}
          variant='rectangular'
          sx={{
            backgroundColor: '#f0f0f0',
            borderRadius: '10px',
            width: '20%',
          }}
        />
      </Box>
      <Box width='100%' display='flex' justifyContent={'center'}>
        <Skeleton
          height={600}
          variant='rectangular'
          sx={{
            backgroundColor: '#f0f0f0',
            borderRadius: '10px',
            width: '100%',
          }}
        />
      </Box>
    </Grid>
  );
}

export default SparksHistoryResultSkeleton;
